/* eslint-disable no-param-reassign */

import { useEffect, useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import useUserStore from '../../../store/user';
import { NodeDataZoneTypes } from '../declaration';
import { makeid } from '../../../utils/helpers';

interface Props {
    cardnumber: number;
    nodeDataZone: NodeDataZoneTypes[];
    setNodeFlag: React.Dispatch<React.SetStateAction<boolean>>;
    setNodeDataZone: React.Dispatch<React.SetStateAction<NodeDataZoneTypes[]>>;
    setNodeCount: (x: number) => void;
    nodeCount: number;
}

const NodeCard = ({ setNodeDataZone, cardnumber, nodeDataZone, setNodeFlag, setNodeCount, nodeCount }: Props) => {
    const [updated, setUpdate] = useState<boolean>(false);

    const user = useUserStore((state) => state.details);

    const unsetHighlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (b.classList.contains('formEmptyText')) {
                    b.classList.remove('formEmptyText');
                }
            } else {
                b.style.borderColor = '#ECEEF3';
            }
        }
    };

    const highlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (!b.classList.contains('formEmptyText')) {
                    b.classList.add('formEmptyText');
                }
            } else {
                b.style.borderColor = 'red';
            }
        }
    };

    const handleInput = (val: string, op: string) => {
        const usernamePattern = /[^a-zA-Z0-9]/g;
        let res;
        const etag = document.getElementById('err');
        switch (op) {
            case 'nodeName':
                if (val.length < 5) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the Node name should not be less than 5.';
                    }
                    highlight(`s3_${cardnumber}`, false);
                    setNodeFlag(false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s3_${cardnumber}`, false);
                    const nObj = nodeDataZone;
                    nObj[cardnumber].nodeName = val;
                    setNodeDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            case 'authUser':
                res = val.match(usernamePattern);
                if (res) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Invalid username format. Use only alphabet and digit.';
                    }
                    highlight(`s1_${cardnumber}`, false);
                } else if (val.length < 8) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the username should not be less than 8.';
                    }
                    highlight(`s1_${cardnumber}`, false);
                } else if (val.length > 20) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the username should not be more than 20.';
                    }
                    highlight(`s1_${cardnumber}`, false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s1_${cardnumber}`, false);
                    const nObj = nodeDataZone;
                    nodeDataZone[cardnumber].authUser = val;
                    setNodeDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            case 'authPassword':
                res = val.match(usernamePattern);
                if (res) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Invalid Password Format. Use only alphabet and digit.';
                    }
                    highlight(`s2_${cardnumber}`, false);
                } else if (val.length < 8) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the password should not be less than 8.';
                    }
                    highlight(`s2_${cardnumber}`, false);
                } else if (val.length > 20) {
                    if (etag) {
                        etag.style.display = 'block';
                        etag.innerHTML = 'Length of the password should not be more than 20.';
                    }
                    highlight(`s2_${cardnumber}`, false);
                } else {
                    if (etag) {
                        etag.style.display = 'none';
                    }
                    unsetHighlight(`s2_${cardnumber}`, false);
                    const nObj = nodeDataZone;
                    nodeDataZone[cardnumber].authPassword = val;
                    setNodeDataZone(nObj);
                }
                setUpdate(!updated);
                break;
            default:
                break;
        }
    };

    const handleRpcAccessPoint = (op: string) => {
        const nObj = nodeDataZone[cardnumber];
        if (op === 'http') {
            nObj.http = !nObj.http;
        }
        if (op === 'ws') {
            nObj.ws = !nObj.ws;
        }
        if (nObj.http === true || nObj.ws === true) {
            unsetHighlight(`s5_${cardnumber}`, true);
        } else {
            highlight(`s5_${cardnumber}`, true);
        }
        setUpdate(!updated);
        setNodeDataZone([nObj]);
    };


    const solve = () => {
        if (
            nodeDataZone[cardnumber].nodeName !== '' &&
            'nodeName' in nodeDataZone[cardnumber] &&
            nodeDataZone[cardnumber].authUser !== '' &&
            'authUser' in nodeDataZone[cardnumber] &&
            nodeDataZone[cardnumber].authPassword !== '' &&
            'authPassword' in nodeDataZone[cardnumber] &&
            (nodeDataZone[cardnumber].http !== false || nodeDataZone[cardnumber].ws !== false) !== false
        ) {
            setNodeFlag(true);
            return;
        }
        if (nodeDataZone[cardnumber].authUser === '' || nodeDataZone[cardnumber].authUser == undefined) {
            setNodeFlag(false);
            highlight(`s1_${cardnumber}`, false);
            return;
        }

        if (nodeDataZone[cardnumber].authPassword === '' || nodeDataZone[cardnumber].authPassword == undefined) {
            setNodeFlag(false);
            highlight(`s2_${cardnumber}`, false);
            return;
        }

        if (nodeDataZone[cardnumber].nodeName === '' || nodeDataZone[cardnumber].nodeName == undefined) {
            setNodeFlag(false);
            highlight(`s3_${cardnumber}`, false);
            return;
        }


        if (!nodeDataZone[cardnumber].http && !nodeDataZone[cardnumber].ws) {
            setNodeFlag(false);
            highlight(`s5_${cardnumber}`, true);
            return;
        }
    };

    useEffect(() => {

        const http = nodeDataZone[cardnumber].http ? true : false;
        const ws = nodeDataZone[cardnumber].ws ? true : false;

        const obj = nodeDataZone;
        obj[cardnumber] = {
            ...obj[cardnumber],
            http,
            ws,
        };
        setNodeDataZone(obj);
        setUpdate(!updated);
    }, []);

    useEffect(() => {
        solve();
    });

    return (
        <div className='mt-5 mb-5 addNodeCard'>
            {/* <h6 className="mt-4  mx-4">Node</h6> */}
            <div className='col-11 mx-4'>
                <div className='row'>
                    <div className='mt-4 col-8 ms-3' title='credentials required to access RPC server of Shardeum'>
                        <h6>
                            RPC Access Credentials
                            <i className=' mx-2 fa fa-info-circle' />
                        </h6>
                    </div>
                </div>

                <div className='row  ms-1'>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='text'
                                className='form-control required'
                                defaultValue={nodeDataZone[cardnumber].authUser}
                                autoComplete='off'
                                placeholder='username'
                                id={`s1_${cardnumber}`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'authUser');
                                }}
                            />

                            <label htmlFor={`s1_${cardnumber}`} className='form-pswd'>
                                Username
                            </label>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='password'
                                className='form-control required'
                                defaultValue={nodeDataZone[cardnumber].authPassword}
                                autoComplete='off'
                                placeholder='password'
                                id={`s2_${cardnumber}`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'authPassword');
                                }}
                            />

                            <label htmlFor={`s2_${cardnumber}`} className='form-pswd'>
                                Password
                            </label>
                        </div>
                    </div>
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <Inputbox
                                type='text'
                                className='form-control required'
                                defaultValue={nodeDataZone[cardnumber].nodeName}
                                autoComplete='off'
                                placeholder='nodename'
                                id={`s3_${cardnumber}`}
                                onChange={(e: { target: { value: string } }) => {
                                    handleInput(e.target.value, 'nodeName');
                                }}
                            />

                            <label htmlFor={`s3_${cardnumber}`} className='form-pswd'>
                                Node Name
                            </label>
                        </div>
                    </div>
                </div>

                <div className='row  ms-1 mt-4'>
                    
                    <div className='col-xl-4 col-lg-4 col-md-12 col-sm-12'>
                        <div className='mt-3 col-11 form-floating cordaversion'>
                            <h6 className='mx-3 mt-3' id={`s5_${cardnumber}`}>
                                Enable RPC Server
                            </h6>
                            <div className='row mt-1 mx-4'>
                                <div className='form-check col-xl-6 col-sm-12 my-2'>
                                    <Inputbox
                                        type='checkbox'
                                        className='form-check-input'
                                        id={`s5-${cardnumber}_http`}
                                        name={'http'}
                                        checked={nodeDataZone[cardnumber].http}
                                        onChange={() => {
                                            handleRpcAccessPoint('http');
                                        }}
                                    />
                                    <label className='form-check-label mx-2' htmlFor={`s5-${cardnumber}_http`}>
                                        HTTP
                                    </label>
                                </div>
                                <div className='form-check col-xl-6 col-sm-12 my-2'>
                                    <Inputbox
                                        type='checkbox'
                                        className='form-check-input'
                                        id={`s5-${cardnumber}_ws`}
                                        name={'ws'}
                                        checked={nodeDataZone[cardnumber].ws}
                                        onChange={() => {
                                            handleRpcAccessPoint('ws');
                                        }}
                                    />
                                    <label className='form-check-label mx-2' htmlFor={`s5-${cardnumber}_ws`}>
                                        WS
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <p id='err' className='text-center mt-4 mb-4' style={{ color: 'red', display: 'none' }}>
                    Error
                </p>
                <p id='err2' className='text-center mt-4 mb-4' style={{ color: 'red', display: 'none' }}>
                    Error
                </p>
            </div>
        </div>
    );
};
export default NodeCard;
